import { eachMinuteOfInterval, subSeconds } from 'date-fns';
import { EventStatusEnum, IUserScheduleFilter, SingleEvent } from 'lingo2-models';

export type TDatetimePickerEventStatus = 'free' | 'busy';

export interface IUserServiceCardCalendar {
  loading: boolean;
  loaded: boolean;
  events: IDatetimePickerEvent[];
  filter: Partial<IUserScheduleFilter>;
  date: Date;
  time: Date[];
}

export interface IDatetimePickerWeekday {
  full: string;
  short: string;
}

export interface IDatetimePickerPeriod {
  start: Date;
  end: Date;
}

export interface IDatetimePickerSelection {
  time: Date[];
  date: Date[];
  start: Date;
  end: Date;
}

export interface IDatetimePickerEvent {
  account_id: string;
  date: Date;
  status: TDatetimePickerEventStatus;
}

export interface IDatetimePickerDate {
  label: string;
  is_active: boolean;
  is_today?: boolean;
  is_busy: boolean;
  is_free: boolean;
  date: Date;
  note?: string;
  events?: IDatetimePickerEvent[];
}

function convertStatus(status: EventStatusEnum): TDatetimePickerEventStatus {
  switch (status) {
    case EventStatusEnum.available:
    case EventStatusEnum.regular:
    case EventStatusEnum.course_reservations:
      return 'free';

    default:
      return 'busy';
  }

  return null;
}

export function convertUserScheduleToDatetimePickerEvent(events: SingleEvent[]): IDatetimePickerEvent[] {
  const _events: IDatetimePickerEvent[] = [];
  events
    .sort((a, b) => b.status - a.status)
    .filter((_se) => _se.begin_at < _se.end_at)
    .map((event) => {
      const interval = {
        start: new Date(event.begin_at),
        end: subSeconds(new Date(event.end_at), 1),
      };
      eachMinuteOfInterval(interval, { step: 30 }).map((hour) => {
        _events.push({ date: hour, status: convertStatus(event.status), account_id: event.account_id });
      });
    });
  return _events;
}

export enum DateFnsDaysOfWeek {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

export function localeWeekFirstDayToDateFns(firstDay: number): DateFnsDaysOfWeek {
  return typeof firstDay === 'number'
    ? {
        1: DateFnsDaysOfWeek.MONDAY,
        2: DateFnsDaysOfWeek.TUESDAY,
        3: DateFnsDaysOfWeek.WEDNESDAY,
        4: DateFnsDaysOfWeek.THURSDAY,
        5: DateFnsDaysOfWeek.FRIDAY,
        6: DateFnsDaysOfWeek.SATURDAY,
        7: DateFnsDaysOfWeek.SUNDAY,
      }[firstDay]
    : null;
}
